import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Login from "../../components/registeration/login";
import Reg from "../../components/registeration/reg";
import { getToken } from "../../utils/tokenStorage";

const Registration = () => {
  const [toggleReg, setToggleReg] = useState<boolean>(true);

  const navigate = useNavigate();

  const token = getToken();

  // Navigate to the dashboard if token is still available in the local storage
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate, token]);

  if (toggleReg) {
    return <Login setToggleReg={setToggleReg} />;
  }
  return <Reg setToggleReg={setToggleReg} />;
};

export default Registration;
